import {Space} from "antd";
import React from "react";
import SupplierCatalog from "./subcomponents/SupplierCatalog/SupplierCatalog";
import GlassCatalog from "./subcomponents/GlassCatalog/GlassCatalog";
import ManufacturerCatalog from "./subcomponents/ManufacturerCatalog/ManufacturerCatalog";
import StoreOfUser from "./subcomponents/StoreOfUser/StoreOfUser";
import GlassSupplies from "./subcomponents/GlassSupplies/GlassSupplies";
import MaterialList from "./subcomponents/MaterialList/MaterialList";
import ColorCatalog from "./subcomponents/ColorCatalog/ColorCatalog";
import CatalogGlassStore from "./subcomponents/CatalogGlassStore/CatalogGlassStore";
import Decentral from "./subcomponents/Decentral/Decentral";

const CatalogManage = () => {
  return (
    <Space direction="vertical" style={{width: "100%"}}>
      <StoreOfUser />
      {/* <Decentral></Decentral> */}
      <SupplierCatalog />
      <GlassCatalog />
      <ManufacturerCatalog />
      <GlassSupplies />
      <MaterialList />
      <ColorCatalog />
      <CatalogGlassStore />
    </Space>
  );
};

export default CatalogManage;
